import React from 'react';
import img1 from './assets/Deep-daan.webp';
import img2 from './assets/Gavshala.webp';
import img3 from './assets/Annadaan.webp';
import img4 from './assets/visesh naivadya seva.webp';
import img5 from './assets/P1240056.00_27_13_05.Still003.webp';
import Kalash from './assets/Kirtan.webp';

import styles from './JCarousel.module.css';

const cards = [
  {
    img: img1,
    title: "Deep Daan In Krtik Mass",
    text: "Behold Lord Sri Radha Shyamsundar in His most exquisite and opulent form on this sacred day.",
    alt: ""
  },
  {
    img: img3,
    title: "Annadaan seva",
    text: " Engage your soul in the uplifting waves of kirtans and bhajans led by senior Vaishnavas.",
    alt: "Shankabhishekam Image"
  },
  {
    img: img2,
    title: "Gau Seva",
    text: "Witness the ceremonial bathing of the Lord with sanctified conch water during the auspicious Maha Shankhabhishekam.",
    alt: "Shankabhishekam Image"
  },
  {
    img: img4,
    title: "Visesh Navidya Seva",
    text: "Gain deep spiritual insights from renowned preachers narrating Krishna's pastimes.",
    alt: "Pushpabhishekam Image"
  },
  {
    img: img5,
    title: "Spritual Discourses",
    text: "Experience a breathtaking offering of fragrant flowers showered upon the Lord.",
    alt: "Kirtans Image"
  },
  {
    img: Kalash,
    title: "Kirtan",
    text: "Participate in the divine Kalash Abhishekam by offering sanctified waters with devotion.",
    alt: "Kalash Abhishekaseva Image"
  },

];

const JCarousel = () => {
  return (
    <div className={styles.carouselContainer}>
      <div className={styles.carouselTrack}>
        {[...cards, ...cards].map((card, i) => (
          <div key={i} className={styles.card}>
            <span>
              <img src={card.img} alt={card.alt} />
            </span>
            <div className={styles.headingSection}>
              <h3>{card.title}</h3>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default JCarousel;
